'use client';

import React, { useCallback, useState, useEffect } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';
import ErrorMessage from '@/components/common/ErrorMessage';

/**
 * Módulo Firmar Contrato:
 * - estatus = "CONTRATO IMPRESO"
 * - Permite editar campos y registrar cuando el contrato fue firmado
 * - Al actualizar fechaEntregaContratoFirmado, cambia automáticamente a "FIRMAR CONTRATO"
 */
const FirmarContratoManagement: React.FC = () => {
  const [initialSolicitudes, setInitialSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFirmarContrato = useCallback(async () => {
    setLoading(true);
    setError(null);
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      setError("No se pudo obtener el ID del usuario actual.");
      setLoading(false);
      return;
    }
    try {
      const response = await solicitudService.getFirmarContrato(currentUser.ownerID);
      if (response.data) {
        setInitialSolicitudes(response.data);
      } else {
        setError(response.error || "Error al cargar solicitudes de Firmar Contrato.");
      }
    } catch (err: any) {
      setError(err.message || "Error de red al cargar solicitudes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFirmarContrato();
  }, [fetchFirmarContrato]);

  if (loading) {
    return <div className="text-center py-4">Cargando solicitudes...</div>;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <SolicitudManagement
      fixedStatus="CONTRATO IMPRESO"
      title="Firmar Contrato"
      modulo="firmar-contrato"
      initialSolicitudes={initialSolicitudes}
      customFetch={fetchFirmarContrato}
      showNewButton={false}
      montoColumn="autorizado"
    />
  );
};

export default FirmarContratoManagement;
